var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 3.75H10.5C6.35786 3.75 3 7.10786 3 11.25V26.25C3 30.3921 6.35786 33.75 10.5 33.75H25.5C29.6421 33.75 33 30.3921 33 26.25V11.25C33 7.10786 29.6421 3.75 25.5 3.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.805C24.1852 19.0533 23.9719 20.3283 23.3907 21.4485C22.8094 22.5687 21.8898 23.4771 20.7625 24.0445C19.6352 24.6119 18.3577 24.8094 17.1117 24.6089C15.8657 24.4084 14.7147 23.8201 13.8223 22.9277C12.9299 22.0353 12.3416 20.8843 12.1412 19.6383C11.9407 18.3923 12.1381 17.1148 12.7055 15.9875C13.2729 14.8602 14.1813 13.9406 15.3015 13.3593C16.4217 12.7781 17.6967 12.5648 18.945 12.75C20.2184 12.9388 21.3973 13.5322 22.3076 14.4424C23.2179 15.3527 23.8112 16.5316 24 17.805Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 10.5H26.2643",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta_icon.a66a0f8c0189dc62d7b1b9a3852b3a65.svg";
export { ForwardRef as ReactComponent };